import { render, staticRenderFns } from "./PatientIdField.vue?vue&type=template&id=10842d89"
import script from "./PatientIdField.vue?vue&type=script&lang=ts"
export * from "./PatientIdField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports